import './index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import RecruitProfile from './RecruitProfile.jsx';
import OrgProfile from './OrgProfile.jsx';
import TeamSheet from './TeamSheet.jsx';
import UniformReport from './UniformReport.jsx';
import Schedule from './Schedule.jsx';
import Unsubscribe from './Unsubscribe.jsx';
import Facility from './Facility.jsx';
import ScoutingReport from './ScoutingReport.jsx';
import { checkStorageOnStartup } from './utils/storageHealth.js';

const path = window.location.pathname;

let RootComponent = App;
let rootProps = {};

if (path.startsWith('/recruit/')) {
  const token = path.slice('/recruit/'.length).split('/')[0];
  RootComponent = RecruitProfile;
  rootProps = { token };
} else if (path.startsWith('/warriors/team/')) {
  const parts = path.split('/');
  RootComponent = TeamSheet;
  rootProps = { teamId: parts[3] || '', tournamentId: parts[4] || '' };
} else if (path === '/unsubscribe' || path === '/unsubscribe/') {
  RootComponent = Unsubscribe;
} else if (path === '/warriors/schedule' || path === '/warriors/schedule/') {
  RootComponent = Schedule;
} else if (path === '/warriors' || path === '/warriors/') {
  RootComponent = OrgProfile;
} else if (path === '/warriors/uniforms' || path === '/warriors/uniforms/') {
  RootComponent = UniformReport;
} else if (path === '/warriors/uniforms/anon' || path === '/warriors/uniforms/anon/') {
  RootComponent = UniformReport;
  rootProps = { anon: true };
} else if (path.startsWith('/warriors/scouting/')) {
  // Generated scouting report (coach/admin only -- enforced by firestore.rules on gcScoutingReports)
  RootComponent = ScoutingReport;
  rootProps = { gameId: decodeURIComponent(path.split('/')[3] || '') };
} else if (path === '/facility' || path.startsWith('/facility')) {
  RootComponent = Facility;
}

// Clear a bloated Firestore cache (if any) before the first render -- see utils/storageHealth.js.
checkStorageOnStartup().finally(() => {
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <RootComponent {...rootProps} />
    </StrictMode>
  );
});
